import { render, staticRenderFns } from "./academic-references-form.vue?vue&type=template&id=3c98b680&"
import script from "./academic-references-form.vue?vue&type=script&lang=js&"
export * from "./academic-references-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports